// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';

export const deactivateOaModalActions = {
  SHOW_DEACTIVATE_OA_MODAL: 'SHOW_DEACTIVATE_OA_MODAL',
  DEACTIVATE_OA_ACTION: 'DEACTIVATE_OA_ACTION'
};

export const showDeactivateOaModalAction = (data: boolean) => ({
  type: deactivateOaModalActions.SHOW_DEACTIVATE_OA_MODAL,
  payload: data
});

export const deactivateOa = (data: Object) => ({
  type: deactivateOaModalActions.DEACTIVATE_OA_ACTION,
  payload: data
});

export const deactivateOaAction = (data: Object) => (dispatch: Function) => {
  dispatch(
    deactivateOa({
      showDeactivateOaModal: true,
      deactivateOa: {
        isLoading: true,
        isLoaded: false,
        refreshTab: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'deactivateOa',
    pathVariables: [{ key: '{userId}', val: data.id }],
    method: 'DELETE',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          deactivateOa({
            showDeactivateOaModal: false,
            deactivateOa: {
              isLoading: false,
              isLoaded: true,
              refreshTab: true,
              data: { status: 'success', val: res }
            }
          })
        );
      } else {
        dispatch(
          deactivateOa({
            showDeactivateOaModal: true,
            deactivateOa: {
              isLoading: false,
              isLoaded: true,
              refreshTab: false,
              data: {
                status: 'error',
                val: res.errorMessage || 'Could not deactivate OA'
              }
            }
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        deactivateOa({
          showDeactivateOaModal: true,
          deactivateOa: {
            isLoading: false,
            isLoaded: true,
            refreshTab: false,
            data: { status: 'failure', val: res }
          }
        })
      );
    },
    catchCb: res => {
      dispatch(
        deactivateOa({
          showDeactivateOaModal: true,
          deactivateOa: {
            isLoading: false,
            isLoaded: true,
            refreshTab: false,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  makeApiCall(requestObj);
};
